export enum ImportationTypeEnum {
  CONTACT = "CONTACT",
  USER = "USER",
  CARD = "CARD"
}

export enum ImportationStatusEnum {
  WAITING = "WAITING",
  RUNNING = "RUNNING",
  DONE = "DONE",
}

export enum ImportationStatusTranslateEnum {
  WAITING = "Aguadando",
  RUNNING = "Em Execução",
  DONE = "Finalizado",
}
